import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar"
import TutorialSection from "./tutorialSection"

const HelpSection = () => {
  const [search, setSearch] = useState("")
  return (
    <div className="h-screen">
      <div className="h-[10vh] pr-2">
        <SearchBar onChange={(e) => {
          setSearch(e.target.value)
        }} title='Help & Tutorials' desc='All available tutorials are listed here.' />
      </div>
      <div className="h-[90vh]">
        <TutorialSection search={search} />
      </div>
    </div>
  );
};

export default HelpSection;
